import React from 'react';

interface Props {
  extractedData: Record<string, any>;
}

export const LinkedInRecentPosts: React.FC<Props> = ({ extractedData }) => {
  const updates = extractedData?.additional_info?.updates || extractedData?.updates || [];
  const updatesList: any[] = Array.isArray(updates) ? updates : [];
  if (updatesList.length === 0) return null;

  return (
    <div className="mt-6">
      <h4 className="text-base font-semibold mb-4 text-gray-900">Recent Posts</h4>
      <div className="space-y-4">
        {updatesList.slice(0, 5).map((update: any, index: number) => (
          <div key={index} className="p-4 rounded-lg border border-gray-200 bg-white">
            {typeof update === 'object' ? (
              <>
                <div className="flex items-start justify-between mb-2">
                  {update.title && <p className="text-sm font-semibold text-gray-900">{update.title}</p>}
                  {update.time && <span className="text-xs text-gray-500">{update.time}</span>}
                </div>
                {update.text && <p className="text-sm mb-3 leading-relaxed text-gray-700">{update.text}</p>}
                {update.images && Array.isArray(update.images) && update.images.length > 0 && (
                  <div className="mb-3">
                    <div className={`grid gap-2 ${update.images.length === 1 ? 'grid-cols-1' : update.images.length === 2 ? 'grid-cols-2' : 'grid-cols-3'}`}>
                      {update.images.slice(0, 3).map((image: string, i: number) => (
                        <img key={i} src={image} alt={`Post ${i + 1}`}
                          className="w-full h-48 object-cover rounded-lg border border-gray-200"
                          onError={(e) => { (e.target as HTMLImageElement).style.display = 'none'; }} />
                      ))}
                    </div>
                  </div>
                )}
                {update.videos && Array.isArray(update.videos) && update.videos.length > 0 && (
                  <div className="mb-3">
                    <video src={update.videos[0]} controls className="w-full rounded-lg border border-gray-200" style={{ maxHeight: 400 }}>
                      Your browser does not support the video tag.
                    </video>
                  </div>
                )}
                <div className="flex items-center justify-between mt-3 pt-3 border-t border-gray-200">
                  <div className="flex items-center gap-4 text-xs text-gray-500">
                    {update.likes_count !== undefined && (
                      <span className="flex items-center gap-1">
                        <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M3.172 5.172a4 4 0 015.656 0L10 6.343l1.172-1.171a4 4 0 115.656 5.656L10 17.657l-6.828-6.829a4 4 0 010-5.656z" clipRule="evenodd" />
                        </svg>
                        {update.likes_count}
                      </span>
                    )}
                    {update.comments_count !== undefined && (
                      <span className="flex items-center gap-1">
                        <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M18 10c0 3.866-3.582 7-8 7a8.841 8.841 0 01-4.083-.98L2 17l1.338-3.123C2.493 12.767 2 11.434 2 10c0-3.866 3.582-7 8-7s8 3.134 8 7zM7 9H5v2h2V9zm8 0h-2v2h2V9zM9 9h2v2H9V9z" clipRule="evenodd" />
                        </svg>
                        {update.comments_count}
                      </span>
                    )}
                  </div>
                  {update.post_url && (
                    <a href={update.post_url} target="_blank" rel="noopener noreferrer"
                      className="text-xs text-blue-600 hover:underline font-medium">
                      View on LinkedIn →
                    </a>
                  )}
                </div>
              </>
            ) : (
              <p className="text-sm text-gray-700">{String(update)}</p>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};
